import ScrollController from '../../assets/js/controllers/scroll';

import { getRootOffsetBounds, multiAddEventListener } from '../../assets/js/helpers';

export default class AnchorLinks {

	static selector = '[data-anchor-links]';

	// class variables

	el = {};

	// constructor

	constructor(container) {
		this.el = {
			container,
			ctas: []
		};

		this.initialize();
	}

	// init

	initialize() {
		const allCtas = this.el.container.querySelectorAll('a');
		for (let i = 0; i < allCtas.length; i++) {
			const $cta = allCtas[i];
			const href = $cta.getAttribute('href');
			const anchorPos = href.indexOf('#') + 1;
			if (anchorPos >= 0) {
				this.el.ctas.push($cta);
			}
		}

		this.#addEventListeners();
	}

	// event listeners

	#addEventListeners = () => {
		multiAddEventListener(this.el.ctas, 'click', this.#onCtaClick);
		multiAddEventListener(this.el.ctas, 'mouseenter', this.#onCtaOver);
		multiAddEventListener(this.el.ctas, 'mouseleave', this.#onCtaOut);
	}

	#removeEventListeners = () => {

	}

	// listener methods

	#onCtaClick = (e) => {
		const $cta = e.currentTarget;
		const href = $cta.getAttribute('href');
		const anchorPos = href.indexOf('#') + 1;
		const paramPos = href.indexOf('?');
		const anchorEnd = paramPos === -1 ? undefined : paramPos;
		const anchorValue = href.substr(anchorPos, anchorEnd);

		const $target = document.documentElement.querySelector(`*[id=${anchorValue}]`);
		const targetBounds = getRootOffsetBounds($target);

		ScrollController.scrollTo(targetBounds.top);

		e.preventDefault();
	}

	#onCtaOver = (e) => {
		const $target = e.currentTarget;
		let $activeCta = null;

		for (let i = 0; i < this.el.ctas.length; i++) {
			const $cta = this.el.ctas[i];
			if ($cta.classList.contains('is-active')) {
				$activeCta = $cta;
			}
		}

		if ($activeCta && $activeCta !== $target) {
			this.el.container.classList.add('is-double-hover');
		}
	}

	#onCtaOut = () => {
		this.el.container.classList.remove('is-double-hover');
	}

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}
